import { SharedPage } from '../base.js';
import { AppConfig } from '../../config.js';

export function createConfirmEmailRequest(code) {
  return {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ code })
  };
}

export class ConfirmEmail extends SharedPage {
  static timl = `
    section.auth-page[aria-labelledby="confirm-email-title"]
      form.stacked-form.auth-form
        header.auth-header
          h1#confirm-email-title Confirm your email
          p#confirm-email-message Please wait while we confirm your email address.
        .auth-loader-wrap#confirm-email-loader
          div.loader
          span Confirming your email…
        .auth-fields#confirm-email-code-label[style="display:none;"]
          label.auth-field
            span Confirmation code
            input#confirm-email-code[name="code" autocomplete="one-time-code" placeholder="Enter your confirmation code"]
        .auth-submit-row#confirm-email-submit-row[style="display:none;"]
          button.auth-primary#confirm-email-submit[type="button"] Confirm email
        .auth-secondary-actions#confirm-email-actions[style="display:none;"]
          p.auth-muted-link
            span Need a new code?
            a[href="/resend-confirmation"] Resend confirmation
          a.auth-back-link[href="/login"] Back to login
  `;

  static setState({ title, message, loading, showActions, showManualEntry }) {
    const titleEl = document.querySelector('#confirm-email-title');
    const messageEl = document.querySelector('#confirm-email-message');
    const loaderEl = document.querySelector('#confirm-email-loader');
    const actionsEl = document.querySelector('#confirm-email-actions');
    const codeLabelEl = document.querySelector('#confirm-email-code-label');
    const submitRowEl = document.querySelector('#confirm-email-submit-row');

    if (titleEl && title) titleEl.innerText = title;
    if (messageEl && message) messageEl.innerText = message;
    if (loaderEl) loaderEl.style.display = loading ? 'flex' : 'none';
    if (actionsEl) actionsEl.style.display = showActions ? 'flex' : 'none';
    if (codeLabelEl) codeLabelEl.style.display = showManualEntry ? 'flex' : 'none';
    if (submitRowEl) submitRowEl.style.display = showManualEntry ? 'block' : 'none';
  }

  static getAuthAppIdFromPath() {
    const parts = Routing.getPathNamePartsFiltered();
    if (parts.length >= 3 && parts[2] === 'confirm-email') {
      return parts[1];
    }
    return '1';
  }

  static submitManualCode() {
    const input = document.querySelector('#confirm-email-code');
    if (!input) return;

    const code = input.value.trim();
    if (!code) {
      input.style.borderColor = 'red';
      input.style.backgroundColor = '#ffeded';
      return;
    }

    const authAppId = this.getAuthAppIdFromPath();
    const nextUrl = `/${Translations.langCode}/${authAppId}/confirm-email?code=${encodeURIComponent(code)}`;
    TIML.handleRedirect(nextUrl);
  }

  static async javascript() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const authAppId = this.getAuthAppIdFromPath();
    const submitButton = document.querySelector('#confirm-email-submit');
    const codeInput = document.querySelector('#confirm-email-code');

    if (submitButton) {
      submitButton.onclick = () => ConfirmEmail.submitManualCode();
    }
    if (codeInput) {
      codeInput.onkeydown = event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        ConfirmEmail.submitManualCode();
      };
    }

    if (!code) {
      ConfirmEmail.setState({
        title: 'Confirm Email',
        message: 'Paste the confirmation code from your email, or request a new confirmation email.',
        loading: false,
        showActions: true,
        showManualEntry: true
      });
      return;
    }

    ConfirmEmail.setState({
      title: 'Confirming Your Email',
      message: 'Please wait while we confirm your email address.',
      loading: true,
      showActions: false,
      showManualEntry: false
    });

    try {
      const response = await fetch(
        `${AppConfig.authServiceApiBaseUrl}/${Translations.langCode}/${authAppId}/confirm-email`,
        createConfirmEmailRequest(code)
      );

      let data = {};
      try {
        data = await response.json();
      } catch (error) {
        data = {};
      }

      if (!response.ok || !data.success || !data.accessToken || !data.refreshToken) {
        throw new Error(data.message || 'That confirmation link may be invalid, expired, or already confirmed.');
      }

      Auth.setAuthenticatedSession(data);
      Auth.ensureSuiteBootstrap().catch(() => {
        // AccountVerified owns the visible error and Retry state for this request.
      });
      TIML.handleRedirect('/' + Translations.langCode + '/account-verified');
    } catch (error) {
      ConfirmEmail.setState({
        title: 'We Could Not Confirm Your Email',
        message: error.message || 'Please check the code and try again, request a new confirmation email, or go to login.',
        loading: false,
        showActions: true,
        showManualEntry: true
      });
    }
  }
}
